import { Type } from "class-transformer";
import { BankAccountDTO } from "../bank-account/bank-account.dto";
import { AddressDTO } from "../document/dto/document-client.dto";
import { ClientKind } from "./client-kind";
import { ClientOtherBuyerRole } from "./client-other-buyer-role";
import { TinKind } from "./tax-identification-numer-kind";

export class ClientDTO {
	public associatedClient: boolean;
	public address: string;
	@Type(() => BankAccountDTO) public bankAccounts: BankAccountDTO[];
	public buyerId: number | null;
	public buyerRole: ClientOtherBuyerRole | null;
	public city: string;
	@Type(() => AddressDTO) public deliveryAddress: AddressDTO | null;
	public groupId: string | null;
	public countryId: number | null;
	public defaultDiscount?: number;
	public defaultDueDate?: number | null;
	public defaultPaymentMethodId?: number;
	public emails: string[];
	public favourite: boolean;
	public id: number;
	public kind: ClientKind;
	public name: string;
	public note: string;
	public phone1: string;
	public phone2: string;
	public skype: string;
	public tin: string;
	public tinKind: TinKind;
	public version: string;
	public website: string;
	public zipCode: string;
    public internalIdentificationNumber: string | null;
}
